import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const CustomDocsRoutes = [
    {
        "url": "/brand/{brand_id:[0-9]*}/custom-docs?document_id?categoryKey",
        "enableUTM": true,
        "name": "appLayout.harriSH.custom-document-wizard",
        "type": "frontend",
        "component": 'customDocumentWizard',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom-docs", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/custom-docs/custom-docs.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/brand/{brand_id:[0-9]*}/custom-docs/${hmapPathParamRegex}?document_id?categoryKey`,
        "enableUTM": true,
        "params": {
            ...hmapPathParamConfig
        },
        "name": "appLayout.harriSH.access-portal.custom-document-wizard",
        "type": "frontend",
        "component": 'customDocumentWizard',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom-docs", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/custom-docs/custom-docs.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/{brand_id:[0-9]*}/custom-docs?duplicate_doc_id&copy_number?categoryKey",
        "enableUTM": true,
        "name": "appLayout.harriSH.duplicate-custom-document",
        "type": "frontend",
        "component": 'customDocumentWizard',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom-docs", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/custom-docs/custom-docs.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/brand/{brand_id:[0-9]*}/custom-docs/${hmapPathParamRegex}?duplicate_doc_id&copy_number?categoryKey`,
        "enableUTM": true,
        "params": {
            ...hmapPathParamConfig
        },
        "name": "appLayout.harriSH.access-portal.duplicate-custom-document",
        "type": "frontend",
        "component": 'customDocumentWizard',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom-docs", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/custom-docs/custom-docs.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=custom-docs.routes.js.map